export const UPDATE_SELECTED_SECTION = "UPDATE_SELECTED_SECTION";

export function updateSelectedPermitId(section) {
    return {type: UPDATE_SELECTED_SECTION, section};
};